module.exports = __webpack_public_path__ + "img/CHEVRON_BOTTOM.59b564dd.svg";